import { useEffect, useRef, useState } from "react";
import { Button } from "antd";
import {
  ShopOutlined,
  AppstoreOutlined,
  ApartmentOutlined,
  BuildOutlined,
  ArrowRightOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./Explore.css";

function useInView(threshold = 0.06) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, vis];
}

function useHeroAnim() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setOn(true), 80);
    return () => clearTimeout(t);
  }, []);
  return (d = 0) => ({
    opacity: on ? 1 : 0,
    transform: on ? "translateY(0)" : "translateY(16px)",
    transition: `all .62s cubic-bezier(.16,1,.3,1) ${d}s`,
  });
}

const categories = [
  {
    num: "01",
    tag: "Property Listings",
    title: "Commercial Spaces",
    desc: "Offices, retail outlets, showrooms, and warehouses available for lease or purchase — listed directly by verified property owners.",
    icon: <ShopOutlined />,
    path: "/commercial-spaces",
  },
  {
    num: "02",
    tag: "Small Business Spaces",
    title: "Stalls",
    desc: "High-potential stall spaces for food, retail, and seasonal setups in markets, malls, and commercial areas across India.",
    icon: <AppstoreOutlined />,
    path: "/stalls",
  },
  {
    num: "03",
    tag: "Investment Opportunities",
    title: "Franchises",
    desc: "Verified franchise opportunities from established brands with clear ROI, operational support, and direct franchisor contact.",
    icon: <ApartmentOutlined />,
    path: "/franchises",
  },
  {
    num: "04",
    tag: "Business Marketplace",
    title: "Businesses",
    desc: "Established businesses available for acquisition or partnership — listed by owners with complete transparency and direct access.",
    icon: <BuildOutlined />,
    path: "/businesses",
  },
  {
    num: "05",
    tag: "Advertising Spaces",
    title: "Ads Business",
    desc: "Promote your brand with billboard and advertising spaces in prime locations with high visibility and traffic.",
    icon: <ShopOutlined />,
    path: "/ads",
  },
];

function Explore() {
  const navigate = useNavigate();
  const anim = useHeroAnim();
  const [ref, vis] = useInView();

  return (
    <div className="fp">

      {/* ── Header ── */}
      <section className="fp-header">
        <div className="fp-header__inner">

          <div style={anim(0.05)}>
            <div className="fp-header__pill">
              <span className="fp-header__pill-dot" />
              Browse Categories
            </div>
          </div>

          <h1 className="fp-header__h1" style={anim(0.13)}>
            Explore Opportunities Across<br />Every Business Category
          </h1>

          <p className="fp-header__sub" style={anim(0.2)}>
            From commercial properties to franchise investments — verified listings,
            direct owner contact, zero commission.
          </p>

        </div>
        <div className="fp-header__fade" />
      </section>

      {/* ── Category rows ── */}
      <section className="fp-cats" ref={ref}>
        <div className="fp-cats__inner">

          <div className={`fp-cats__label rv ${vis ? "in" : ""}`}>
            <div className="fp-cats__label-line" />
            <span className="fp-cats__label-text">5 Categories</span>
            <div className="fp-cats__label-line" />
          </div>

          {categories.map((cat, i) => (
            <div
              key={cat.title}
              className={`fp-row rv d${(i % 3) + 1} ${vis ? "in" : ""}`}
              onClick={() => navigate(cat.path)}
            >
              <div className="fp-row__num">{cat.num}</div>

              <div className="fp-row__body">
                <div className="fp-row__meta">
                  <span className="fp-row__tag">{cat.tag}</span>
                </div>
                <div className="fp-row__title">{cat.title}</div>
                <p className="fp-row__desc">{cat.desc}</p>
              </div>

              <div className="fp-row__right">
                <div className="fp-row__icon-wrap">{cat.icon}</div>
                <Button
                  className="fp-row__btn"
                  onClick={(e) => { e.stopPropagation(); navigate(cat.path); }}
                >
                  View listings <ArrowRightOutlined />
                </Button>
              </div>
            </div>
          ))}

        </div>
      </section>

      {/* ── CTA ── */}
      <div className="fp-cta">
        <div className="fp-cta__inner">
          <h2 className="fp-cta__h2">Ready to list your own?</h2>
          <p className="fp-cta__sub">
            Post your commercial space, business, stall, or franchise opportunity
            for free — reach serious buyers with direct contact.
          </p>
          <Button
            type="primary"
            className="fp-cta__btn"
            onClick={() => navigate(
              localStorage.getItem("token") ? "/add" : "/login"
            )}
          >
            <PlusOutlined /> Post a free listing
          </Button>
        </div>
      </div>

    </div>
  );
}

export default Explore;